export default {
  GET_QUOTE_COORDINADORA: `#graphql
  query getQuoteCoordinadora($packagingName: String!, $locationOrigin: String!, $departmentOrigin: String!, $locationDestination: String!, $departmentDestination: String!, $value: Int!, $isCod: Boolean!, $packageDimensions: CoordinadoraPackageDimensionsInput, $packages: [CoordinadoraGuidePackageInput]) {
    getQuoteCoordinadora(packagingName: $packagingName, locationOrigin: $locationOrigin, departmentOrigin: $departmentOrigin, locationDestination: $locationDestination, departmentDestination: $departmentDestination, value: $value, isCod: $isCod, packageDimensions: $packageDimensions, packages: $packages)
  }`,

  GET_TRACKING_COORDINADORA: `#graphql
  query getTrackingCoordinadora($tracking: String!) {
    getTrackingCoordinadora(tracking: $tracking) {
      code
      description
      date
      hour
    }
  }`,

  GENERATE_DELIVERY_COORDINADORA: `#graphql
  mutation generateDeliveryCoordinadora($order: String!, $package: String!, $valueDeclared: Int!, $cost: Int!, $isChange: Boolean!, $collectFreight: Boolean, $packageDimensions: CoordinadoraPackageDimensionsInput, $packages: [CoordinadoraGuidePackageInput]) {
    generateDeliveryCoordinadora(order: $order, package: $package, valueDeclared: $valueDeclared, cost: $cost, isChange: $isChange, collectFreight: $collectFreight, packageDimensions: $packageDimensions, packages: $packages) {
      idRemission,
      tracking,
      cost,
      estimatedCost
    }
  }`,

  GENERATE_LABELS_COORDINADORA: `#graphql
  mutation generateLabelsCoordinadora($idsRemission: [String]!) {
    generateLabelsCoordinadora(idsRemission: $idsRemission)
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/coordinadora.js